import { connect } from 'react-redux';
import Products from './Products';


let mapStateToProps = (state) => {
  return {
    productsData: state.productsPage.productsData
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const ProductsContainer = connect(mapStateToProps, mapDispatchToProps)(Products);

export default ProductsContainer;